import cx from 'classnames'
import type React from 'react'

import type { AttachmentItem } from '@/types/models'
import Item from './Item'
import css from './List.module.scss'

type Props = {
  files: AttachmentItem[]
  selectedSet: Set<string>
  isScrollable: boolean
  onClick: (file: AttachmentItem) => void
  selectedIds: Array<string>
  setSelectedIds: Function
}

const List: React.FC<Props> = ({
  files,
  isScrollable,
  selectedSet,
  onClick,
  selectedIds,
  setSelectedIds,
}) => {
  const checkIsSelected = (file: AttachmentItem) => selectedSet.has(file.id)

  const containerClassName = cx(css.list, {
    [css.scrollable]: isScrollable,
  })

  return (
    <div className={containerClassName}>
      {files.map((file) => (
        <Item
          key={file.id}
          file={file}
          isSelected={checkIsSelected(file)}
          onClick={onClick}
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
        />
      ))}
    </div>
  )
}

export default List
